var map = {
	"./Default": 61251,
	"./Default.tsx": 61251,
	"./Detailed": 25466,
	"./Detailed.tsx": 25466,
	"./Mobilecard": 59078,
	"./Mobilecard.tsx": 59078,
	"./Mobilecardtwo": 89214,
	"./Mobilecardtwo.tsx": 89214,
	"./Mobiletwocolumn": 31234,
	"./Mobiletwocolumn.tsx": 31234,
	"./type": 40686,
	"./type.ts": 40686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87738;